import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const PermissaoList = props => <DefaultDataTable data={props} />;
